import React from 'react';
import type { LucideIcon } from 'lucide-react';

interface AuthFormFieldProps {
  label: string;
  htmlFor: string;
  icon?: LucideIcon;
  children: React.ReactNode;
  className?: string;
}

const AuthFormField: React.FC<AuthFormFieldProps> = ({
  label,
  htmlFor,
  icon: Icon,
  children,
  className = '',
}) => (
  <div className={className}>
    <label htmlFor={htmlFor} className="mb-1.5 block text-sm font-semibold text-[#001848]">
      {label}
    </label>
    <div className="group relative">
      {Icon && (
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3.5">
          <Icon className="h-[18px] w-[18px] text-slate-400 transition-colors group-focus-within:text-gold-500" />
        </div>
      )}
      {children}
    </div>
  </div>
);

export const authInputClass =
  'block w-full rounded-xl border border-slate-200 bg-slate-50/60 py-3 text-sm text-[#001848] shadow-sm transition-all duration-200 placeholder:text-slate-400 focus:border-gold-400 focus:bg-white focus:outline-none focus:ring-2 focus:ring-gold-400/25 disabled:cursor-not-allowed disabled:bg-slate-100';

export const authInputWithIconClass = `${authInputClass} pr-10 pl-4`;
export const authInputPlainClass = `${authInputClass} px-4`;

export default AuthFormField;
